import React from 'react';
import { CategoriesRC, FooterLinksItemRC, FooterLinksListRC, MobileBannerRC, NavigationItemRC, NavigationListRC, StoresBlockRC, TabsItemRC, TabsListRC } from "../../connected";
import { MenuAnimationWrapperRC, RegionRC, SearchAnimationWrapperRC } from "../../../../connected";
import { NavigationWrapper } from "./components/NavigationWrapper";
import { NavigationBlockWrapper } from "./components/NavigationBlockWrapper";
import { NavigationFooterWrapper } from "./components/NavigationFooterWrapper";
import { Search } from "../../../Search";
export var Mobile = function Mobile() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchAnimationWrapperRC, {
    "data-t-id": "components-Mobile"
  }, /*#__PURE__*/React.createElement(NavigationBlockWrapper, {
    isFullHeight: true,
    "data-t-id": "components-Mobile"
  }, /*#__PURE__*/React.createElement(Search, {
    "data-t-id": "components-Mobile"
  }))), /*#__PURE__*/React.createElement(MenuAnimationWrapperRC, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavigationWrapper, null, /*#__PURE__*/React.createElement(CategoriesRC, {
    "data-t-id": "components-Mobile"
  }), /*#__PURE__*/React.createElement(TabsListRC, null, /*#__PURE__*/React.createElement(TabsItemRC, {
    "data-t-id": "components-Mobile"
  }))), /*#__PURE__*/React.createElement(NavigationBlockWrapper, null, /*#__PURE__*/React.createElement(NavigationListRC, {
    "data-t-id": "components-Mobile"
  }, /*#__PURE__*/React.createElement(NavigationItemRC, {
    "data-t-id": "components-Mobile"
  }))), /*#__PURE__*/React.createElement(MobileBannerRC, null), /*#__PURE__*/React.createElement(NavigationWrapper, null, /*#__PURE__*/React.createElement(NavigationFooterWrapper, {
    "data-t-id": "components-Mobile"
  }, /*#__PURE__*/React.createElement(RegionRC, {
    isInMenu: true,
    "data-t-id": "components-Mobile"
  }), /*#__PURE__*/React.createElement(FooterLinksListRC, null, /*#__PURE__*/React.createElement(FooterLinksItemRC, {
    "data-t-id": "components-Mobile"
  })), /*#__PURE__*/React.createElement(StoresBlockRC, null))))));
};